import React, { useEffect } from 'react';
import PT from "prop-types";
import get from "lodash/get";
import useUrl from '../../../hook/useUrl';
import StoryHeaderWow from "../story-header-wow";
import { SocialShare } from "@quintype/components";
import useSocialShareLinks from '../../../hook/useSocialShareLinks';
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryPaywallComponent from "../../atoms/paywalls/story-paywall-component";
import "./wow.m.css";

const WowStory = ({ story }) => {
  const [_,currentUrlSlug]=useUrl();
  let domainSlug=""
  if(currentUrlSlug==="vaasalehti"){
    domainSlug="vaasa"
  }else{
    domainSlug="ilkka-pohjalainen"
  }
  const socialShareLinks= useSocialShareLinks(story,domainSlug);
  var colorTheme = "default";
  if ((get(story, ["metadata", "story-attributes", "taustavariwaujuttuun", 0])) !== undefined) {
    colorTheme = get(story, ["metadata", "story-attributes", "taustavariwaujuttuun", 0]);
  }
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    if (colorTheme === "sininen" || colorTheme === "musta") {
      window.dataLayer.push({
        'sivupohja': 'tumma-wow'
      })
    }
  }, []);
  const metakeywords = story["seo"]["meta-keywords"];
  const hashtags = metakeywords ? metakeywords.map (item => {
    return item.replace(/ /g, "");
  }) : "";
  return (
    <React.Fragment>
  <div styleName="wow-template">
    <div styleName={colorTheme} className={colorTheme}>
      <div styleName="top-container">
        <div styleName="main-container">
          <div styleName="main">
          </div>
          <div styleName="blank-story" className="voice-article">
            <div styleName="story-header">
              <StoryHeaderWow story={story} />
            </div>
            <div styleName="story-container" className="story-container">

              {<div styleName="sticky-social-share">
                <SocialShare
                  template={StickySocialShareTemplate}
                  story={story}
                  title={story.headline}
                  fullUrl={socialShareLinks}
                  hashtags={story["seo"]["meta-keywords"] ? hashtags.join(",") : ""}
                  color="#000"
                  sticky
                />
              </div>}
              {/*{((accessType === "login" || accessType === "subscription" || accessType === null) && (!checkUser || (checkUser && !activeProducts))) ? !whiteListed ? (<div><PaywallComponent text={text} /></div>) : <StoryComponent story={story} showAds={false} allTagIds={allTagIds}/> :
                <StoryComponent story={story} showAds={false} allTagIds={allTagIds}/>}*/}
              <StoryPaywallComponent story={story} showAds={false}/>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    </React.Fragment>
  );
}

WowStory.propTypes = {
  story: PT.object,
  isActive: PT.bool
};

export { WowStory };
